import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { Breadcrumb, Checkbox, message, Button, Tooltip } from 'antd';

import Table from 'components/Table';
import { elipsis } from 'shared/utils/StringUtil';
import { permissionService } from 'shared/services';
import { userPermissions, FILTER_TYPE, paginationParam } from 'shared/constant';
import NewFilter from 'components/NewFilter';

import text from './EmployeeRoleList.page.translation';
// import EmployeeRoleListFilter from './EmployeeRoleList.filter';
import organizationRoute from '../../route';

import './EmployeeRoleList.style.less';

class EmployeeRoleList extends Component {
  constructor(props) {
    super(props);
    const { resetFilter, match } = this.props;
    if (!match.params.page) {
      resetFilter();
    }
  }

  componentDidMount() {
    this.refreshRoleTable();
  }

  refreshRoleTable = () => {
    const { match, filterValue } = this.props;

    if (match.params.page) {
      this.updateRoleTable(filterValue);
    } else {
      this.updateRoleTable([]);
    }
  };

  componentDidUpdate(prevProps) {
    const { formControlShow, match, filterValue } = this.props;

    if (prevProps.match.params.page !== match.params.page) {
      this.updateRoleTable(filterValue);
    }

    if (prevProps.filterValue !== filterValue && !formControlShow) {
      if (
        !(
          prevProps.filterValue.length > 0 &&
          prevProps.filterValue.length > filterValue.length &&
          prevProps.filterValue[prevProps.filterValue.length - 1].inputValue
            .length === 0
        )
      ) {
        if (
          prevProps.match.params.page !== match.params.page ||
          (prevProps.match.params.page === match.params.page &&
            match.params.page > 1)
        ) {
          this._handleChangePage(1);
        } else {
          this.updateRoleTable(filterValue);
        }
      }
    }
  }
  _setDynamicColumn = roles => {
    let column = [];
    column = roles.map(role => {
      const singleRole = {
        title: role,
        key: '',
        width: 200,
        align: 'center',
        render: this._renderDynamicColumn(role),
      };
      return singleRole;
    });
    return column;
  };

  _renderDynamicColumn = role => record => {
    const identifier = _.get(record, 'module.identifier', '');
    const checked = role === identifier;
    return <Checkbox defaultChecked={checked} disabled />;
  };

  _renderNoColumn = (pageNum, pageSize) => (_text, _record, index) => {
    const result = index + 1 + pageSize * (pageNum - 1);
    return result;
  };

  _renderCurrentStatusColumn = record => {
    const {
      intl: { formatMessage },
    } = this.props;
    const getDeactivateStatus = _.get(record, 'deactivated', true);
    let setText = formatMessage(text.deactive);
    let setCSS = 'deactivatedStatus';
    if (getDeactivateStatus === false) {
      setText = formatMessage(text.active);
      setCSS = 'activatedStatus';
    }
    return <span className={setCSS}>{setText}</span>;
  };

  _renderDeactivateColumn = record => {
    const {
      intl: { formatMessage },
    } = this.props;
    const getDeactivateStatus = _.get(record, 'deactivated', true);
    const getId = _.get(record, 'id', '');
    let deactivatedStatusText = formatMessage(text.deactivate);
    let deactivatedCSS = 'deactivated';
    if (getDeactivateStatus) {
      deactivatedStatusText = formatMessage(text.activate);
      deactivatedCSS = 'activated';
    }

    return (
      <button
        type="button"
        className={deactivatedCSS}
        onClick={() => {
          this._handlerDeactivated(getDeactivateStatus, getId);
        }}
      >
        <span>{deactivatedStatusText}</span>
      </button>
    );
  };

  _openEmployeeRoleDetail = record => () => {
    this.props.history.push(
      organizationRoute.EMPLOYEE_ROLE_DETAIL.replace(':id', record.id),
    );
  };

  _renderEmployeeRoleName = record => {
    const getRoleName = _.get(record, 'name', '');
    return (
      <button
        type="button"
        className="btn-details left-text"
        onClick={this._openEmployeeRoleDetail(record)}
      >
        <Tooltip placement="topLeft" title={getRoleName}>
          <span>{elipsis(getRoleName, 30)}</span>
        </Tooltip>
      </button>
    );
  };

  _getRowId = row => row.id;

  _getRole = employeeRoleList => {
    const roleData = [];

    if (employeeRoleList && employeeRoleList.length > 0) {
      const allModuleIds = employeeRoleList.map(x => x.module.identifier);
      const filteredModule = allModuleIds.filter(
        (val, index, arr) => arr.indexOf(val) === index,
      );

      return filteredModule;
    }

    return roleData;
  };

  _tableColumns = (pageNum, pageSize) => {
    const {
      intl: { formatMessage },
      employeeRoleList,
    } = this.props;

    const getRole = this._getRole(employeeRoleList);

    const getDynamic = this._setDynamicColumn(getRole);

    const canUpdateRole =
      permissionService.checkPermission(userPermissions.UPDATE_ROLE, true) &&
      permissionService.checkPermission(userPermissions.READ_ROLE, true);

    const tableColumn = [
      {
        title: formatMessage(text.no),
        key: 'index',
        width: 100,
        align: 'center',
        render: this._renderNoColumn(pageNum, pageSize),
      },
      {
        title: formatMessage(text.employeeRoleName),
        key: 'name',
        width: 300,
        render: this._renderEmployeeRoleName,
      },
      {
        title: formatMessage(text.employeeRoleDescription),
        key: 'description',
        dataIndex: 'description',
        width: 400,
      },
      {
        title: formatMessage(text.labelCurrentStatus),
        key: '',
        width: 200,
        align: 'center',
        render: this._renderCurrentStatusColumn,
      },
    ];

    if (canUpdateRole) {
      tableColumn.push({
        title: formatMessage(text.labelAction),
        key: '',
        width: 200,
        align: 'center',
        render: this._renderDeactivateColumn,
      });
    }

    tableColumn.splice(3, 0, ...getDynamic);

    return tableColumn;
  };

  _handleChangePage = page => {
    const { history } = this.props;

    const url = organizationRoute.EMPLOYEE_ROLE_LIST_FILTER.replace(
      ':page',
      page,
    );
    history.push(url);
  };

  _callbackDeactivated = deactivated => {
    const {
      intl: { formatMessage },
    } = this.props;
    if (deactivated) {
      message.success(formatMessage(text.notifDeactivatedSuccess));
    } else {
      message.success(formatMessage(text.notifActivatedSuccess));
    }

    this.refreshRoleTable();
  };

  _handlerDeactivated = (deactivated, id) => {
    if (deactivated) {
      this.props.activateEmployeeRole(id, this._callbackDeactivated);
    } else {
      this.props.deactivateEmployeeRole(id, this._callbackDeactivated);
    }
  };

  _renderBtnCreateRole = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Button
        type="primary"
        block
        className="btn register-vendor-btn"
        htmlType="submit"
      >
        <Link to={organizationRoute.EMPLOYEE_ROLE_REGISTER}>
          {formatMessage(text.btnCreateRole)}
        </Link>
      </Button>
    );
  };

  _countTotalPage = () => {
    const { pagination } = this.props;
    let totalPage = 0;

    if (pagination) {
      const totalItem =
        _.get(pagination, 'page_size', 0) * _.get(pagination, 'page_count', 0);
      totalPage = totalItem;
    }

    return totalPage;
  };

  _getSumWidth = (total, item) => total + item.width;

  buildGetParamUrl = filterValue => {
    let result = '';

    filterValue.forEach(element => {
      const value = element.inputValue[0];
      switch (element.key) {
        default:
          result += `&${element.key}=${value}`;
          break;
      }
    });

    return result;
  };

  buildPaginationUrl = pagination => {
    let result = '';
    result += `page_size=${encodeURIComponent(pagination.page_size)}`;
    result += `&page_count=${encodeURIComponent(pagination.page_count)}`;
    result += `&page_num=${encodeURIComponent(pagination.page_num)}`;

    return result;
  };

  updateRoleTable = filterValue => {
    const { getEmployeeRole, pagination, match, history } = this.props;

    let paginationValue = { ...paginationParam };
    let paramUrl = '';

    const page = _.get(match, 'params.page', '');
    const pageInt = parseInt(page, 10) || '';

    if (filterValue.length > 0) {
      paramUrl += this.buildGetParamUrl(filterValue);
    }

    if (page) {
      if (pageInt && pageInt >= 1) {
        paginationValue = {
          ...pagination,
          page_num: pageInt,
        };
        const paginationUrl = this.buildPaginationUrl(paginationValue);
        getEmployeeRole(paginationUrl, paramUrl);
      } else {
        history.push(organizationRoute.EMPLOYEE_ROLE_LIST);
      }
    } else {
      const paginationUrl = this.buildPaginationUrl(paginationValue);
      getEmployeeRole(paginationUrl, paramUrl);
    }
  };

  render() {
    const {
      intl: { formatMessage },
      employeeRoleList,
      pagination,
    } = this.props;

    const pageSize = _.get(pagination, 'page_size');
    const pageNum = _.get(pagination, 'page_num');
    const totalPage = this._countTotalPage();
    const tableColumns = this._tableColumns(pageNum, pageSize);
    const sumWidth = tableColumns.reduce(this._getSumWidth, 0);
    const scrollX = sumWidth + 10;

    const canCreateRole =
      permissionService.checkPermission(userPermissions.CREATE_ROLE, true) &&
      permissionService.checkPermission(userPermissions.READ_ROLE, true);

    const options = [
      {
        label: 'Employee Role',
        value: 'name',
        type: FILTER_TYPE.TEXT,
      },
    ];

    return (
      <div className="main-content">
        <div className="breadcrumb-wrapper">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {formatMessage(text.breadcrumbEmployeeRoleList)}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="white-box-wrapper">
          <span className="title mbottom30">
            {formatMessage(text.employeeRolesTitle)}
          </span>

          {canCreateRole && this._renderBtnCreateRole()}

          <NewFilter options={options} />

          <div className="table-wrapper employee-role-list-table">
            <Table
              rowID={this._getRowId}
              columns={tableColumns}
              dataSource={employeeRoleList}
              pagination="true"
              rowClass="striped-table"
              totalItem={totalPage}
              changePage={this._handleChangePage}
              loadingValue={this.props.getLoading}
              currentPage={pageNum}
              scrollX={scrollX}
            />
          </div>
        </div>
      </div>
    );
  }
}

EmployeeRoleList.propTypes = {
  history: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  getEmployeeRole: PropTypes.func.isRequired,
  employeeRoleList: PropTypes.array,
  getLoading: PropTypes.bool,
  activateEmployeeRole: PropTypes.func.isRequired,
  deactivateEmployeeRole: PropTypes.func.isRequired,
  pagination: PropTypes.object,
  filterValue: PropTypes.array,
  formControlShow: PropTypes.bool,
  resetFilter: PropTypes.func,
  match: PropTypes.object,
};

export default EmployeeRoleList;
